<app-detail-view-template *ngIf="Data$ | async as data; else loadingTemplate">
    <ng-container *appDetailViewButtons>
        <button
            *ngIf="!data.editing && !data.managedUser.Deleted"
            app-round-button
            Inverted
            class="header-button"
            matTooltip="Bearbeiten"
            aria-label="Bearbeiten"
            (click)="OpenEdit.next()"
        >
            <fa-icon icon="pencil-alt"></fa-icon>
        </button>

        <button
            *ngIf="data.editing"
            app-round-button
            Color="green"
            class="header-button"
            matTooltip="Speichern"
            aria-label="Speichern"
            [Disabled]="ManagedUserForm.invalid"
            (click)="Save.next()"
        >
            <fa-icon icon="save"></fa-icon>
        </button>
        <button
            *ngIf="data.editing"
            app-round-button
            Inverted
            class="header-button"
            matTooltip="Zurücksetzen"
            aria-label="Zurücksetzen"
            (click)="CloseEdit.next()"
        >
            <fa-icon icon="undo"></fa-icon>
        </button>


        <button
            *ngIf="!data.managedUser.Deleted && data.editing"
            app-round-button
            class="header-button"
            Color="red"
            matTooltip="Löschen"
            aria-label="Löschen"
            (click)="DeleteUser.next()"
        >
            <fa-icon icon="trash"></fa-icon>
        </button>
    </ng-container>

    <ng-container *appDetailViewLeftContent>
        <app-profile-template
            [Data]="data.profileData"
            [Editing]="data.editing"
            (Submit)="Save.next()"
        ></app-profile-template>
    </ng-container>

    <ng-container *appDetailViewRightContent>
        <app-license-list
            [Editing]="data.editing"
            [User]="data.managedUser"
            [ChangedEmail]="data.managedUser.Email !== ManagedUserForm.value.Email"
        ></app-license-list>
    </ng-container>
</app-detail-view-template>

<ng-template #loadingTemplate>
    <app-loading></app-loading>
</ng-template>
